export default "__VITE_ASSET__CA7Rx$DP__"